module.exports = __webpack_public_path__ + "img/CTS_Drop.eb1e8ee5.jpg";